// extracted by mini-css-extract-plugin
module.exports = {"incidentIndication":"WhatPage_incidentIndication__3PGSE"};